package com.milta.di

import com.milta.core.appconfig.AppConfigApi
import com.milta.core.appconfig.AppConfigRepository
import com.milta.core.appconfig.AppConfigRepositoryImpl
import com.milta.core.auth.SessionManager
import com.milta.core.mode.AppModeManager
import com.milta.core.network.RouteRealtimeClient
import com.milta.core.network.buildHttpClient
import com.milta.feature.auth.data.remote.AuthApi
import com.milta.feature.auth.data.repository.AuthRepositoryImpl
import com.milta.feature.auth.domain.repository.AuthRepository
import com.milta.feature.delivery.data.remote.DeliveryApi
import com.milta.feature.delivery.data.repository.DeliveryRepositoryImpl
import com.milta.feature.delivery.domain.repository.DeliveryRepository
import com.milta.feature.delivery.domain.usecase.CreateDeliveryUseCase
import com.milta.feature.imports.data.remote.ImportApi
import com.milta.feature.imports.data.remote.ImportPdfApi
import com.milta.feature.imports.data.repository.ImportPdfRepositoryImpl
import com.milta.feature.imports.data.repository.ImportRepositoryImpl
import com.milta.feature.imports.domain.repository.ImportPdfRepository
import com.milta.feature.imports.domain.repository.ImportRepository
import com.milta.feature.imports.domain.usecase.ExtractDeliveriesFromPdfUseCase
import com.milta.feature.imports.domain.usecase.RetryImportUseCase
import com.milta.feature.imports.domain.usecase.StartImportUseCase
import com.milta.feature.ocrscan.data.remote.OcrScanApi
import com.milta.feature.ocrscan.data.repository.OcrScanRepositoryImpl
import com.milta.feature.ocrscan.domain.repository.OcrScanRepository
import com.milta.feature.ocrscan.domain.usecase.ScanDeliveryPhotoUseCase
import com.milta.feature.packagelabelscan.data.remote.PackageLabelScanApi
import com.milta.feature.packagelabelscan.data.repository.PackageLabelScanRepositoryImpl
import com.milta.feature.packagelabelscan.domain.repository.PackageLabelScanRepository
import com.milta.feature.packagelabelscan.domain.usecase.ScanPackageLabelUseCase
import com.milta.feature.profile.data.remote.ProfileApi
import com.milta.feature.profile.data.repository.ProfileRepositoryImpl
import com.milta.feature.profile.domain.repository.ProfileRepository
import com.milta.feature.profile.domain.usecase.ConfirmAccountDeletionUseCase
import com.milta.feature.profile.domain.usecase.ConfirmPhoneChangeUseCase
import com.milta.feature.profile.domain.usecase.GetMyDriverLinkCodeUseCase
import com.milta.feature.profile.domain.usecase.GetProfileUseCase
import com.milta.feature.profile.domain.usecase.RequestAccountDeletionUseCase
import com.milta.feature.profile.domain.usecase.RequestPhoneChangeUseCase
import com.milta.feature.profile.domain.usecase.UpdateLanguageUseCase
import com.milta.feature.route.data.local.PendingDeliveryValidationLocalDataSource
import com.milta.feature.route.data.remote.RouteApi
import com.milta.feature.route.data.repository.OfflineSyncRepositoryImpl
import com.milta.feature.route.data.repository.RouteRepositoryImpl
import com.milta.feature.route.domain.repository.OfflineSyncRepository
import com.milta.feature.route.domain.repository.RouteRepository
import com.milta.feature.route.domain.usecase.AddDeliveriesToRouteUseCase
import com.milta.feature.route.domain.usecase.CompleteRouteUseCase
import com.milta.feature.route.domain.usecase.CreateOwnRouteUseCase
import com.milta.feature.route.domain.usecase.CreateRouteBatchUseCase
import com.milta.feature.route.domain.usecase.CreateRouteUseCase
import com.milta.feature.route.domain.usecase.DeleteRouteUseCase
import com.milta.feature.route.domain.usecase.DispatchRouteBatchUseCase
import com.milta.feature.route.domain.usecase.DispatchRouteUseCase
import com.milta.feature.route.domain.usecase.GetMyRouteUseCase
import com.milta.feature.route.domain.usecase.GetMyRoutesUseCase
import com.milta.feature.route.domain.usecase.GetRouteDetailUseCase
import com.milta.feature.route.domain.usecase.GetRouteHistoryUseCase
import com.milta.feature.route.domain.usecase.GetRouteProofsUseCase
import com.milta.feature.route.domain.usecase.GetTeamRoutesOverviewUseCase
import com.milta.feature.route.domain.usecase.ImportRouteFileUseCase
import com.milta.feature.route.domain.usecase.OptimizeRouteUseCase
import com.milta.feature.route.domain.usecase.RegeocodeRouteUseCase
import com.milta.feature.route.domain.usecase.RemoveDeliveryFromRouteUseCase
import com.milta.feature.route.domain.usecase.ReoptimizeInPlaceUseCase
import com.milta.feature.route.domain.usecase.ReoptimizeRouteBatchUseCase
import com.milta.feature.route.domain.usecase.StartRouteUseCase
import com.milta.feature.route.domain.usecase.ValidateDeliveryUseCase
import com.milta.feature.team.data.remote.TeamApi
import com.milta.feature.team.data.repository.TeamRepositoryImpl
import com.milta.feature.team.domain.repository.TeamRepository
import com.milta.feature.team.domain.usecase.DeleteEnterpriseUseCase
import com.milta.feature.team.domain.usecase.GetEnterpriseDriversUseCase
import com.milta.feature.team.domain.usecase.GetMyEnterpriseUseCase
import com.milta.feature.team.domain.usecase.GetMyTeamUseCase
import com.milta.feature.team.domain.usecase.LinkDriverUseCase
import com.milta.feature.team.domain.usecase.RemoveDriverUseCase
import com.milta.feature.subscription.data.remote.SubscriptionApi
import com.milta.feature.subscription.data.repository.SubscriptionRepositoryImpl
import com.milta.feature.subscription.domain.repository.SubscriptionRepository
import com.milta.feature.subscription.domain.usecase.GetMySubscriptionUseCase
import com.milta.feature.subscription.domain.usecase.GetSubscriptionPlansUseCase
import com.milta.feature.subscription.domain.usecase.SubmitReceiptUseCase
import com.milta.feature.spreadsheetimport.data.remote.SpreadsheetImportApi
import com.milta.feature.spreadsheetimport.data.repository.SpreadsheetImportRepositoryImpl
import com.milta.feature.spreadsheetimport.domain.repository.SpreadsheetImportRepository
import com.milta.feature.spreadsheetimport.domain.usecase.ImportSpreadsheetUseCase
import org.koin.dsl.module

val authModule = module {
    single { SessionManager() }
    single<AuthRepository> { AuthRepositoryImpl(get(), get(), get(), get(), get()) }
}

val modeModule = module {
    single { AppModeManager(get()) }
}

// Ad hoc feature (2026-08) — RoutaR kill switch, shared by mobile and webApp (see AppConfigRepositoryImpl).
val appConfigModule = module {
    single<AppConfigRepository> { AppConfigRepositoryImpl(get()) }
}

val profileModule = module {
    single<ProfileRepository> { ProfileRepositoryImpl(get(), get()) }
    factory { GetProfileUseCase(get()) }
    factory { UpdateLanguageUseCase(get()) }
    factory { RequestPhoneChangeUseCase(get()) }
    factory { ConfirmPhoneChangeUseCase(get()) }
    factory { RequestAccountDeletionUseCase(get()) }
    factory { ConfirmAccountDeletionUseCase(get()) }
    factory { GetMyDriverLinkCodeUseCase(get()) }
}

val subscriptionModule = module {
    single<SubscriptionRepository> { SubscriptionRepositoryImpl(get(), get()) }
    factory { GetMySubscriptionUseCase(get()) }
    factory { SubmitReceiptUseCase(get()) }
    factory { GetSubscriptionPlansUseCase(get()) }
    // MIL-18 Phase 3: PurchaseClient is platform-specific (real BillingManager on Android via
    // billing-ktx, no StoreKit implementation on iOS yet) — bound in each platform's own module
    // (see androidModule), not here, to avoid a definition conflict. SubscriptionScreen is the
    // only caller and is never composed on the web target, so jsModule doesn't need one either.
}

// NOTE (MIL-35/screen unification): DeliveryRepository is still used for address autocomplete by
// DeliveryEntrySheet (feature.route.presentation) — CreateDeliveryUseCase itself (the retired
// two-step CreateDelivery + Optimize flow) has no caller left. Left registered (unused) rather than
// deleting the whole feature.delivery package, which is outside this ticket's scope.
val deliveryModule = module {
    single<DeliveryRepository> { DeliveryRepositoryImpl(get()) }
    factory { CreateDeliveryUseCase(get()) }
}

val routeModule = module {
    single<RouteRepository> { RouteRepositoryImpl(get(), get()) }
    factory { GetMyRouteUseCase(get()) }
    factory { GetMyRoutesUseCase(get()) }
    factory { CreateOwnRouteUseCase(get()) }
    factory { StartRouteUseCase(get()) }
    factory { CompleteRouteUseCase(get()) }
    factory { ReoptimizeInPlaceUseCase(get()) }
    factory { CreateRouteUseCase(get()) }
    factory { ImportRouteFileUseCase(get()) }
    factory { OptimizeRouteUseCase(get()) }
    factory { DispatchRouteUseCase(get()) }
    factory { AddDeliveriesToRouteUseCase(get()) }
    // MIL-38 — Manager team dashboard + route detail (Enterprise view)
    factory { GetTeamRoutesOverviewUseCase(get()) }
    factory { GetRouteDetailUseCase(get()) }
    // MIL-52 — "Historique des preuves de livraison" (Screen A history list + Screen B proofs grid)
    factory { GetRouteHistoryUseCase(get()) }
    factory { GetRouteProofsUseCase(get()) }
    // MIL-45 — manual re-geocode from the route detail screen
    factory { RegeocodeRouteUseCase(get()) }
    single { RouteRealtimeClient(get()) }
    factory { RemoveDeliveryFromRouteUseCase(get()) }
    // MIL-65 — delete a not-yet-started route from the Accueil Livreur screen
    factory { DeleteRouteUseCase(get()) }
    // MIL-39 — multi-driver batch dispatch
    factory { CreateRouteBatchUseCase(get()) }
    factory { ReoptimizeRouteBatchUseCase(get()) }
    factory { DispatchRouteBatchUseCase(get()) }
    // MIL-41 — proof of delivery (photo + status + comment)
    factory { ValidateDeliveryUseCase(get()) }
}

// MIL-43 — offline validation queue, persisted via LocalCacheStore (mode hors ligne). `single`
// shared by every screen rather than recreated per-screen, so the in-memory StateFlow stays
// consistent across navigation even though the source of truth is now on disk.
val offlineSyncModule = module {
    single { PendingDeliveryValidationLocalDataSource(get()) }
    single<OfflineSyncRepository> { OfflineSyncRepositoryImpl(get(), get()) }
}

val importsModule = module {
    single<ImportRepository> { ImportRepositoryImpl(get()) }
    factory { StartImportUseCase(get()) }
    factory { RetryImportUseCase(get()) }
    // MIL-26 — POST /imports/pdf, distinct endpoint/contract from the MIL-29 flow above.
    single<ImportPdfRepository> { ImportPdfRepositoryImpl(get()) }
    factory { ExtractDeliveriesFromPdfUseCase(get()) }
}

val ocrScanModule = module {
    single<OcrScanRepository> { OcrScanRepositoryImpl(get()) }
    factory { ScanDeliveryPhotoUseCase(get()) }
}

val packageLabelScanModule = module {
    single<PackageLabelScanRepository> { PackageLabelScanRepositoryImpl(get()) }
    factory { ScanPackageLabelUseCase(get()) }
}

val spreadsheetImportModule = module {
    single<SpreadsheetImportRepository> { SpreadsheetImportRepositoryImpl(get()) }
    factory { ImportSpreadsheetUseCase(get()) }
}

val teamModule = module {
    single<TeamRepository> { TeamRepositoryImpl(get(), get()) }
    factory { GetMyTeamUseCase(get()) }
    factory { GetEnterpriseDriversUseCase(get()) }
    factory { LinkDriverUseCase(get()) }
    factory { RemoveDriverUseCase(get()) }
    // MIL-53 — Dashboard Web "Paramètres"
    factory { GetMyEnterpriseUseCase(get()) }
    factory { DeleteEnterpriseUseCase(get()) }
}

val networkModule = module {
    single { buildHttpClient(get(), get()) }
    single { AuthApi(get()) }
    single { AppConfigApi(get()) }
    single { ProfileApi(get()) }
    single { SubscriptionApi(get()) }
    single { DeliveryApi(get()) }
    single { RouteApi(get()) }
    single { TeamApi(get()) }
    single { ImportApi(get()) }
    single { ImportPdfApi(get()) }
    single { OcrScanApi(get()) }
    single { PackageLabelScanApi(get()) }
    single { SpreadsheetImportApi(get()) }
}
